import PropTypes from 'prop-types';
import { useDictionary } from '../../../../../../../utilities/hooks/UseDictionary';
import CustomerBookingItem from './CustomerBookingItem';
import {useHistory} from 'react-router-dom'
import { NavigatorPaths } from '../../../../../../../assets/dictionaries/NavigatorPaths';

const CustomerBooking = ({details}) => {
    const dictionary  = useDictionary();
    const history = useHistory();

    const onBookingClicked = (detals) => {
        history.push(`/${NavigatorPaths.bookings.path}/${detals.id}`);
    }
    
    return (
        <div className="detail-tab-container thin-scrollbar fade-on-load">
            <div
				className="participant-row-container"
				style={{ justifyContent: 'space-between', marginBottom: '16px' }}
			>
				<h3>
					{dictionary.all_bookings}
				</h3>
			</div>
            {
                (details.bookings && details.bookings.length > 0) ? (
                    <table style={{ marginLeft: -8, borderCollapse: "collapse" }} className='provider-customer-booking-listing'>
                        <tbody>
                            {details.bookings.map(item => (
                                <CustomerBookingItem
                                    key={item.id}
                                    onBookingClicked={() => onBookingClicked(item)}
                                    booking={item}
                                />
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="empty-provider-customers-list-placeholder d-flex-center">
                        <div className="empty-booking-image empty-provider-customers-details-image"/>
                        <h3
                            data-testid="no-bookings-yet-header"
                            className='empty-provider-customers-title'
                        >
                            {dictionary.no_bookings_yet}
                        </h3>
                        <div className="text empty-provider-customers-message">
                            {dictionary.all_bookings_will_be_listed}
                        </div>
                    </div>
                )
            }
        </div>
    )
}

CustomerBooking.propTypes = {
	details: PropTypes.object
};

export default CustomerBooking;